module.exports = __webpack_public_path__ + "static/logo-512x512-115d45cfc7fffd27410cf5f409ec790e.png";